// extracted by mini-css-extract-plugin
module.exports = {"jobsListWrapper":"JobsList_jobsListWrapper__oHafz"};